document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".header-wrapper"); // Asegúrate de que sea la clase correcta

  window.addEventListener("scroll", function () {
    if (window.scrollY > 50) { 
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  });
});